import React, { useState, useEffect } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import getMetadaAdobe from "../../utils/buttons/getMetadaAdobe";
import { getCachedScript } from "../../utils/scriptCache.js";
import { getItem, setItem } from "../../utils/cepStorage";

function SplitTemplate({
  onPopupStateChange,
  selectedTag,
  buttonTag,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible("SplitTemplateVisibility");
  const [selectedCategory, setSelectedCategory] = useVisible(
    "SplitTemplateCategory"
  );
  const [partsSuffix, setPartsSuffix] = useVisible(
    "SplitTemplateFilePartsSuffix"
  );
  const [parts, setParts] = useVisible("SplitTemplateParts");
  const [collectFiles, setCollectFiles] = useState(true);
  const [stock, setStock] = useVisible("SplitTemplateStock");
  const [userParts, setUserParts] = useState(
    Number(getItem("SplitTemplateUserParts")) || 2
  );

  // сразу под импортами, до объявления компонента
  const categoryOptions = [
    { label: "Backgrounds", id: 10 },
    { label: "Infographics", id: 11 },
    { label: "Logo Reveals", id: 26 },
    { label: "Lower Thirds", id: 7 },
    { label: "Motion Effects", id: 30 },
    { label: "Motion Overlays", id: 31 },
    { label: "Slideshows", id: 38 },
    { label: "Titles", id: 40 },
    { label: "Transitions", id: 9 },
  ];

function writeLog(message) {
  try {
    const logPath = "/tmp/zip-cep-debug.log";
    const timestamp = new Date().toISOString();
    const logLine = `[${timestamp}] ${message}\n`;
    
    let existing = "";
    const readResult = window.cep.fs.readFile(logPath);
    if (readResult.err === 0) {
      existing = readResult.data;
    }
    
    const newContent = existing + logLine;
    window.cep.fs.writeFile(logPath, newContent);
  } catch (e) {}
}

function zipOnMac(archives) {
  writeLog("=== НАЧАЛО АРХИВАЦИИ ===");
  const successList = [];
  const failList = [];
  const errorList = [];
  
  const processArchive = (index) => {
    if (index >= archives.length) {
      writeLog("=== ВСЕ АРХИВЫ ОБРАБОТАНЫ ===");
      showResults(successList, failList, errorList);
      return;
    }
    
    const a = archives[index];
    let tempFolder = null;
    
    try {
      tempFolder = `/tmp/zip_temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      writeLog("1. Временная папка: " + tempFolder);
      
      let mkdirResult = window.cep.process.createProcess("/bin/mkdir", "-p", tempFolder);
      if (mkdirResult.err !== 0) throw new Error("mkdir ошибка");
      
      window.cep.process.onquit(mkdirResult.data, function() {
        writeLog("2. Папка создана");
        copyFilesRecursive(a.files, tempFolder, 0, function() {
          handleNestedZip(a.name, tempFolder, a.finalPath, successList, failList, errorList, index, archives, processArchive);
        });
      });
    } catch (e) {
      writeLog("CRITICAL: " + e.message);
      errorList.push(a.name);
      processArchive(index + 1);
    }
  };
  
  processArchive(0);
}

function copyFilesRecursive(files, tempFolder, fileIndex, callback) {
  if (fileIndex >= files.length) {
    writeLog("4. Копирование завершено");
    callback();
    return;
  }
  
  const file = files[fileIndex];
  writeLog("3." + fileIndex + " Копирование");
  
  try {
    let cpResult;
    if (file.type === "folder") {
      cpResult = window.cep.process.createProcess("/bin/bash", "-c", `cp -R "${file.path}" "${tempFolder}/" 2>/dev/null || true`);
    } else {
      cpResult = window.cep.process.createProcess("/bin/cp", file.path, tempFolder + "/");
    }
    
    if (cpResult.err === 0) {
      window.cep.process.onquit(cpResult.data, function() {
        writeLog("   OK");
        copyFilesRecursive(files, tempFolder, fileIndex + 1, callback);
      });
    } else {
      writeLog("   ERROR: " + cpResult.err);
      copyFilesRecursive(files, tempFolder, fileIndex + 1, callback);
    }
  } catch (e) {
    writeLog("   EXCEPTION: " + e.message);
    copyFilesRecursive(files, tempFolder, fileIndex + 1, callback);
  }
}

function handleNestedZip(archiveName, tempFolder, finalPath, successList, failList, errorList, index, archives, processArchive) {
  const needsNestedZip = archiveName.indexOf("_PR_") !== -1 || archiveName.indexOf("_AE_") !== -1;
  
  if (needsNestedZip) {
    writeLog("5. Вложенный архив требуется");
    
    // Находим папку с цифрами, архивируем её СОДЕРЖИМОЕ
    const nestedCmd = `
      cd "${tempFolder}"
      
      # Находим папку, начинающуюся с цифры
      for item in [0-9]*/; do
        if [ -d "$item" ]; then
          folderName="\${item%/}"
          echo "Found folder: $folderName"
          
          # Заходим ВНУТРЬ папки и архивируем содержимое
          cd "$folderName"
          /usr/bin/zip -r "../$folderName.zip" . -x "*.DS_Store"
          cd ..
          
          # Удаляем исходную папку
          rm -rf "$folderName"
          
          echo "Created: $folderName.zip"
          break
        fi
      done
    `;
    
    const nestedResult = window.cep.process.createProcess("/bin/bash", "-c", nestedCmd);
    
    if (nestedResult.err === 0) {
      writeLog("5a. Вложенный архив PID: " + nestedResult.data);
      
      window.cep.process.stdout(nestedResult.data, function(output) {
        writeLog("5a-stdout: " + output);
      });
      
      window.cep.process.onquit(nestedResult.data, function(exitCode) {
        writeLog("5b. Вложенный архив завершён, код: " + exitCode);
        
        setTimeout(function() {
          createMainZip(archiveName, tempFolder, finalPath, successList, failList, errorList, index, archives, processArchive);
        }, 300);
      });
    } else {
      writeLog("5c. Ошибка запуска: " + nestedResult.err);
      createMainZip(archiveName, tempFolder, finalPath, successList, failList, errorList, index, archives, processArchive);
    }
  } else {
    writeLog("5. Вложенный архив не требуется");
    createMainZip(archiveName, tempFolder, finalPath, successList, failList, errorList, index, archives, processArchive);
  }
}

function createMainZip(archiveName, tempFolder, finalPath, successList, failList, errorList, index, archives, processArchive) {
  const outZip = finalPath + "/" + archiveName + ".zip";
  writeLog("6. Выходной архив: " + outZip);
  
  // ДИАГНОСТИКА: Проверяем что во временной папке
  const lsCmd = `ls -la "${tempFolder}" && ls -laR "${tempFolder}"`;
  const lsResult = window.cep.process.createProcess("/bin/bash", "-c", lsCmd);
  
  if (lsResult.err === 0) {
    window.cep.process.stdout(lsResult.data, function(output) {
      writeLog("СОДЕРЖИМОЕ tempFolder:\n" + output);
    });
  }
  
  try {
    const rmResult = window.cep.process.createProcess("/bin/rm", "-f", outZip);
    
    window.cep.process.onquit(rmResult.data, function() {
      writeLog("7. Старый ZIP удален");
      
      // ДИАГНОСТИКА: Проверяем путь назначения
      writeLog("7a. Проверка пути: " + finalPath);
      
      const mkdirCmd = `mkdir -p "${finalPath}"`;
      const mkdirResult = window.cep.process.createProcess("/bin/bash", "-c", mkdirCmd);
      
      window.cep.process.onquit(mkdirResult.data, function() {
        writeLog("7b. Папка назначения создана/проверена");
        
        // ZIP команда с выводом ошибок в файл
        const errorLog = "/tmp/zip_error_" + Date.now() + ".log";
        const zipCmd = `cd "${tempFolder}" && /usr/bin/zip -r "${outZip}" . -x "*.DS_Store" > "${errorLog}" 2>&1; echo "EXIT:$?" >> "${errorLog}"`;
        
        writeLog("8. ZIP команда: " + zipCmd);
        
        const result = window.cep.process.createProcess("/bin/bash", "-c", zipCmd);
        
        if (result.err !== 0) {
          writeLog("8a. CreateProcess ошибка: " + result.err);
          errorList.push(archiveName);
          cleanupAndContinue(tempFolder, index, archives, successList, failList, errorList, processArchive);
          return;
        }
        
        const pid = result.data;
        writeLog("9. ZIP PID: " + pid);
        
        // Ждём завершения
        setTimeout(function() {
          // Читаем лог ошибок
          const catResult = window.cep.process.createProcess("/bin/cat", errorLog);
          if (catResult.err === 0) {
            window.cep.process.stdout(catResult.data, function(output) {
              writeLog("ZIP OUTPUT: " + output);
            });
          }
          
          checkZipCompletion(pid, archiveName, tempFolder, finalPath, outZip, successList, failList, errorList, index, archives, processArchive);
        }, 2000);
      });
    });
  } catch (e) {
    writeLog("CRITICAL in createMainZip: " + e.message);
    errorList.push(archiveName);
    cleanupAndContinue(tempFolder, index, archives, successList, failList, errorList, processArchive);
  }
}

function checkZipCompletion(pid, archiveName, tempFolder, finalPath, outZip, successList, failList, errorList, index, archives, processArchive) {
  writeLog("10. Проверка ZIP процесса");
  
  let checkCount = 0;
  let notRunningCount = 0;
  
  const checkInterval = setInterval(function() {
    checkCount++;
    
    try {
      const isRunningResult = window.cep.process.isRunning(pid);
      
      if (checkCount <= 5) {
        writeLog("10." + checkCount + " isRunning: " + isRunningResult.data);
      }
      
      if (isRunningResult.err === 0) {
        if (isRunningResult.data === false) {
          notRunningCount++;
        } else {
          notRunningCount = 0;
        }
      }
      
      // Если 3 раза подряд false
      if (notRunningCount >= 3) {
        clearInterval(checkInterval);
        writeLog("10a. ZIP завершился");
        
        // Проверяем файл
        const checkCmd = `[ -f "${outZip}" ] && echo "EXISTS" || echo "NOT"`;
        const checkResult = window.cep.process.createProcess("/bin/bash", "-c", checkCmd);
        
        if (checkResult.err === 0) {
          window.cep.process.onquit(checkResult.data, function() {
            successList.push(archiveName);
            writeLog("11. ✓ Архив: " + archiveName);
            cleanupAndContinue(tempFolder, index, archives, successList, failList, errorList, processArchive);
          });
        } else {
          successList.push(archiveName);
          writeLog("11. ✓ Архив: " + archiveName);
          cleanupAndContinue(tempFolder, index, archives, successList, failList, errorList, processArchive);
        }
      }
      
      if (checkCount >= 150) {
        clearInterval(checkInterval);
        writeLog("10b. Timeout");
        successList.push(archiveName);
        cleanupAndContinue(tempFolder, index, archives, successList, failList, errorList, processArchive);
      }
    } catch (e) {
      writeLog("10E: " + e.message);
    }
  }, 1000);
}

function cleanupAndContinue(tempFolder, index, archives, successList, failList, errorList, processArchive) {
  writeLog("12. Очистка");
  const rmResult = window.cep.process.createProcess("/bin/rm", "-rf", tempFolder);
  window.cep.process.onquit(rmResult.data, function() {
    writeLog("13. Очистка OK");
    processArchive(index + 1);
  });
}

function showResults(successList, failList, errorList) {
  const resultMessage = [];
  
  if (successList.length > 0) {
    resultMessage.push("Successfully Created:\n\n" + successList.map(x => x + ".zip").join("\n"));
  }
  if (failList.length > 0) {
    resultMessage.push("Creation Fail:\n\n" + failList.map(x => x + ".zip").join("\n"));
  }
  if (errorList.length > 0) {
    resultMessage.push("Critical Error:\n\n" + errorList.map(x => x + ".zip").join("\n"));
  }
  
  const finalMessage = resultMessage.join("\n\n");
  const escapedMessage = finalMessage.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n');
  window.jsx.evalScript(`alert("${escapedMessage}")`);
  
  writeLog("=== FINAL ===\n" + finalMessage);
}

  const handleClick = (script, argument) => {
    getCachedScript();
    window.jsx.evalScript(
      `run(${script}(${JSON.stringify(argument)}));`,
      function (result) {
        if (result) {
          if (script === "createZipSplitTemplate") {
            // Если мы на macOS — JSX вернул JSON, а не текст
            if (
              typeof result === "string" &&
              result.startsWith("[") &&
              result.endsWith("]")
            ) {
              // Это ZIP-данные → передаём в CEP ZIP систему
              const archives = JSON.parse(result);
              zipOnMac(archives); // <-- Эту функцию ниже пишу
              return;
            }
          }

          if (stock === "adobe" && script.includes("Metadata")) {
            const data = JSON.parse(result);
            const names = data.names.map((item) => item.name);
            data.selectedCategory = selectedCategory;
            const prompt = `You will be given a list of project names typically used for stock video templates on marketplaces like Videohive or MotionArray.
Your task:
- For each name, generate a list of at least 20 relevant stock keywords (in English).
- Ignore numeric suffixes (like 01, 02, Part 1, Vol. 2, etc.).
- If multiple names share the same base name and differ only by numbering, return the same keyword list for all of them.
- Keywords should reflect the project's type, style, theme, and purpose.
- Do not include any text, code blocks, markdown formatting, or explanations.
- Only return a raw JSON array of keyword arrays, like:
[["keyword1", "keyword2", ...], ["keyword1", "keyword2", ...]]
Names:${JSON.stringify(names)}`;

            getMetadaAdobe(data, prompt);
          }
        }
      }
    );
  };

  const handleStockChange = (event) => {
    setStock(event.target.value);
    console.log("Stock selected:", event.target.value);
  };

  const handleSuffixChange = (event) => {
    setPartsSuffix(event.target.value);
    console.log("Parts suffix:", event.target.value);
  };

  useEffect(() => {
    setItem("SplitTemplateUserParts", userParts);
  }, [userParts]);

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isVisible);
    }
  }, [isVisible]);

  if (selectedTag && selectedTag !== buttonTag) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-sharp fa-regular fa-columns-3"></i>
        </div>
        <div className="button-card__title">Split Template</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="parts"
              checked={parts}
              onChange={() => {
                setParts(!parts);
              }}
              className="hidden-checkbox"
            />
            <label htmlFor="parts">
              <span className="custom-checkbox"></span>
              <span className="label-text">User Parts</span>
            </label>
          </div>

          {collectFiles && (
            <div className="render-group__dropdown">
              <span className="render-group__dropdown-text">Stock</span>
              <select value={stock} onChange={handleStockChange}>
                <option value=" ">Classic</option>
                <option value="adobe">Adobe Stock</option>
              </select>
            </div>
          )}

          {collectFiles && stock === "adobe" && (
            <div className="render-group__dropdown">
              <span className="render-group__dropdown-text">Category</span>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {categoryOptions.map(({ label, id }) => (
                  <option key={id} value={id}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="render-group__dropdown">
            <span className="render-group__dropdown-text">Add To The Name</span>
            <select value={partsSuffix} onChange={handleSuffixChange}>
              <option value=" ">None</option>
              <option value=" Part ">Part</option>
              <option value=" Vol.">Vol.</option>
              <option value=" Slide ">Slide</option>
            </select>
          </div>

          {parts && (
            <div className="rename__input-group">
              <span className="render-group__dropdown-text">Set Parts</span>
              <input
                className="rename__input shape__input"
                type="number"
                value={userParts}
                onChange={(e) => setUserParts(e.target.value)}
                onBlur={() => {
                  if (Number(userParts) < 2) {
                    setUserParts(2);
                  }
                }}
                placeholder="Parts"
                min="2"
              />
            </div>
          )}
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() =>
              handleClick("ppSplitTemplate", {
                userParts: !parts ? false : userParts,
                partsSuffix: partsSuffix,
                collectFiles: collectFiles,
                stock: stock,
              })
            }
            className="render-group__button"
          >
            <i class="fa-solid fa-scissors"></i>
            <span className="render-group__button-text">Split</span>
          </div>
          {!parts && (
            <>
              <div
                onClick={() =>
                  handleClick("exportMediaPreviewSplitTemplate", {
                    exportType: "thumbnail",
                    userParts: !parts ? false : userParts,
                    partsSuffix: partsSuffix,
                    collectFiles: collectFiles,
                    stock: stock,
                  })
                }
                className="render-group__button"
              >
                <i class="fa-sharp fa-regular fa-image"></i>
                <span className="render-group__button-text">Thumbnail</span>
              </div>
              <div
                onClick={() =>
                  handleClick("exportMediaPreviewSplitTemplate", {
                    exportType: "video",
                    userParts: !parts ? false : userParts,
                    partsSuffix: partsSuffix,
                    collectFiles: collectFiles,
                    stock: stock,
                  })
                }
                className="render-group__button"
              >
                <i class="fa-sharp fa-light fa-film"></i>
                <span className="render-group__button-text">Preview</span>
              </div>
              <div
                onClick={() =>
                  handleClick("createSplitTemplateTutorial", {
                    userParts: !parts ? false : userParts,
                    partsSuffix: partsSuffix,
                    collectFiles: collectFiles,
                    stock: stock,
                  })
                }
                className="render-group__button"
              >
                <i class="fa-sharp fa-regular fa-comment-text"></i>
                <span className="render-group__button-text">Tutorial</span>
              </div>
              {stock === "adobe" && (
                <div
                  onClick={() =>
                    handleClick("exportSplitTemplateMetadata", {
                      userParts: !parts ? false : userParts,
                      fileExtension: stock === "adobe" ? true : false,
                      partsSuffix: partsSuffix,
                      collectFiles: collectFiles,
                      stock: stock,
                    })
                  }
                  className="render-group__button"
                >
                  <i class="fa-light fa-database"></i>
                  <span className="render-group__button-text">Metadata</span>
                </div>
              )}
              <div
                onClick={() =>
                  handleClick("createZipSplitTemplate", {
                    userParts: !parts ? false : userParts,
                    fileExtension: stock === "adobe" ? true : false,
                    partsSuffix: partsSuffix,
                    collectFiles: collectFiles,
                    stock: stock,
                  })
                }
                className="render-group__button"
              >
                <i class="fa-sharp fa-light fa-file-zip"></i>
                <span className="render-group__button-text">Zip</span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default SplitTemplate;
